"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.DropdownWithIntl = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DropdownBody_1 = require("./DropdownBody");
var alignPoints = ["bl tl", "tl bl", "br tr", "tr br"];
/*
 * TODO: same thing is in sdk-ui-ext .. but filters must not depend on it. we may be in need of some lower-level
 *  project on which both of filters and ext can depend. perhaps the purpose of the new project would be to provide
 *  thin layer on top of goodstrap (?)
 */
var DROPDOWN_ALIGNMENTS = alignPoints.map(function (align) { return ({ align: align, offset: { x: 1, y: 0 } }); });
var DropdownWrapped = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownWrapped, _super);
    function DropdownWrapped() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onApply = function (operator, value, treatNullValuesAsZero) {
            _this.props.onApply(operator, value, treatNullValuesAsZero);
        };
        return _this;
    }
    DropdownWrapped.prototype.render = function () {
        var _a = this.props, operator = _a.operator, value = _a.value, usePercentage = _a.usePercentage, warningMessage = _a.warningMessage, locale = _a.locale, onCancel = _a.onCancel, anchorEl = _a.anchorEl, separators = _a.separators, displayTreatNullAsZeroOption = _a.displayTreatNullAsZeroOption, treatNullAsZeroValue = _a.treatNullAsZeroValue, enableOperatorSelection = _a.enableOperatorSelection;
        var selectedOperator = operator !== null ? operator : "ALL";
        return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { alignTo: anchorEl, alignPoints: DROPDOWN_ALIGNMENTS, closeOnOutsideClick: true, closeOnParentScroll: true, closeOnMouseDrag: true, onClose: onCancel },
            react_1.default.createElement(DropdownBody_1.DropdownBody, { operator: selectedOperator, value: value, usePercentage: usePercentage, warningMessage: warningMessage, locale: locale, onCancel: onCancel, onApply: this.onApply, separators: separators, displayTreatNullAsZeroOption: displayTreatNullAsZeroOption, treatNullAsZeroValue: treatNullAsZeroValue, enableOperatorSelection: enableOperatorSelection })));
    };
    DropdownWrapped.defaultProps = {
        value: {},
        operator: "ALL",
        displayTreatNullAsZeroOption: false,
        treatNullAsZeroValue: false,
    };
    return DropdownWrapped;
}(react_1.default.PureComponent));
exports.DropdownWithIntl = react_intl_1.injectIntl(DropdownWrapped);
var Dropdown = /** @class */ (function (_super) {
    tslib_1.__extends(Dropdown, _super);
    function Dropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dropdown.prototype.render = function () {
        return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: this.props.locale },
            react_1.default.createElement(exports.DropdownWithIntl, tslib_1.__assign({}, this.props))));
    };
    return Dropdown;
}(react_1.default.PureComponent));
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map